import React from 'react';
import { connect } from 'react-redux';
import { createMeetingRoom, resetMeetingRoomForm } from '../../../../actions/meetingRoom';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowCreateMeetingRoomModal } from '../../../../actions/modal';

@connect()
export default class RightPanelCreate extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      meetingRoomForm: props.meetingRoomForm,
    };
    this.resetForm = this.resetForm.bind(this);
    this.createMeetingRoom = this.createMeetingRoom.bind(this);
    this.cancelCreateMeetingRoom = this.cancelCreateMeetingRoom.bind(this);
    // this.handleEnterCreateMeeting = this.handleEnterCreateMeeting.bind(this);
  }
  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({ meetingRoomForm: props.meetingRoomForm });
  }

  createMeetingRoom() {
    let areThereErrors = forceValidation(undefined, undefined, 'createMeetingRoomForm');
    if (!areThereErrors) {
      if (this.state.meetingRoomForm.name == 'error') {
        this.props.dispatch(displayGlobalMessage({ visible: true }));
      } else {
        let cb = () => {
          let show = false;
          this.props.dispatch(updateShowCreateMeetingRoomModal(show));
          this.resetForm(); //timeout waiting for the hide effect to finish
        };
        this.props.dispatch(createMeetingRoom(this.state.meetingRoomForm, cb));
      }
    }
  }

  componentWillUnmount() {}

  cancelCreateMeetingRoom() {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) this.props.dispatch(hideGlobalMessage());
    let show = false;
    this.props.dispatch(updateShowCreateMeetingRoomModal(show));
    this.resetForm();
  }

  resetForm() {
    //TODO : CLEAR DROPDOWN
    this.props.dispatch(resetMeetingRoomForm());
  }

  render() {
    let saveClasses =
      'ui labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull';

    return (
      <div className="ui actions mrbl max-width ">
        <button
          type="button"
          tabIndex="3"
          onClick={this.createMeetingRoom}
          data-group="createMeetingRoomForm"
          className={this.state.meetingRoomForm.fetching ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Create}
          <i className="add  icon" />
        </button>
        <button
          type="button"
          tabIndex="4"
          onClick={this.cancelCreateMeetingRoom}
          className="ui   labeled icon button color-bad-things color-bad-things-hover color-white    mrtm max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    );
  }
}
